<script>
import {LoanBankAccount} from "@/models/LoanPayment/LoanBankAccount";
import BankAccountSelectItem from "@components/ui/BankAccountSelect/BankAccountSelectItem.vue";

export default {
  name: "BankAccountSelect",
  components: {BankAccountSelectItem},
  props: {
    value: {
      type: LoanBankAccount|null,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
  },
  computed: {
    differentBankAccounts() {
      return this.options.filter((option) => option.id !== this.value.id)
    }
  },
  data: () => ({
    openChildren: false
  }),
  methods: {
    changeValue(ev) {
      this.$emit("input", ev)
    }
  }
}
</script>

<template>
  <div class="w-full z-50 relative cursor-pointer" @click="openChildren = !openChildren">
    <bank-account-select-item
        active
        :bank-account="value"></bank-account-select-item>

    <div
        id="bankAccountSubItem"
        :class="{'hidden': !openChildren, 'absolute': openChildren}"
        class="animate__animated animate__fadeIn animate__faster  bg-white border-1 rounded-lg px-1 py-2 shadow-lg"
    >
      <bank-account-select-item
          @click="changeValue"
          class="mb-1"
          v-for="option in differentBankAccounts" :bank-account="option"></bank-account-select-item>

      <div
          class="p-5 text-grey-300"
          v-if="differentBankAccounts.length === 0">
        No hay mas cuentas bancarias para seleccionar
      </div>
    </div>
  </div>
</template>

<style scoped>
#bankAccountSubItem {
  top: -1rem;
  right: -21rem;
  width: 300px;
}
</style>